import { BRAND_IMAGE } from 'constants/brand'
import { getRelativeUrlReduxUtil } from 'modules/redux/utils/get-url'
import getValueReduxUtil from 'modules/redux/utils/get-value'

/**
 * Gets the properties necessary to share.
 * @param  {Object} instance
 * @returns {Object}
 *         {string} title
 *         {string} url
 *         {string} img
 */
function getSharePropsModelUtil (instance) {
  return {
    title: getValueReduxUtil(instance, 'title'),
    url: getRelativeUrlReduxUtil(instance),
    img: (
      getValueReduxUtil(instance, 'shareImg') ||
      getValueReduxUtil(instance, 'img') ||
      BRAND_IMAGE
    )
  }
}

export {
  getSharePropsModelUtil
}
